// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo, useState}
    from 'react';
import {Settings_context} from '../settings_ctx';
import {use_pathname} from './use_pathname';
import {Button} from './button';
import {Input} from './input';
import {Textarea} from './textarea';
import {Checkbox} from './checkbox';
import styles from './content.module.less';
import cn from 'classnames';
import {use_screen} from './screen_util';
import {use_client} from '../../../shared/hooks/use_client';

export interface I_element {
    id: string; // for overrides
    type: string;
    props: any;
    is_from_react_app?: boolean;
    container_wrap?: boolean;
    client_side_rendering?: boolean;
    client_alive_rendering?: boolean;
}

export interface I_content_props {
    elements?: I_element[];
    just_meta?: boolean;
}

interface I_add_element_props {
    on_add: ()=>void;
    on_drop: ()=>void;
}
export const Add_element = (props:I_add_element_props)=>{
    const [drag_class, set_drag_class] = useState(false);
    return <div className={cn(styles.add_btn, drag_class && styles.drag)}
      onDrop={()=>{
        props.on_drop();
        set_drag_class(true);
      }}
      onDragOver={ev=>{
        ev.preventDefault();
        set_drag_class(true);
      }}
      onDragLeave={()=>set_drag_class(false)}>
      <div className={styles.line}/>
      <Button caption={'Add here +'} on_click={props.on_add} size={'xxs'}/>
      <div className={styles.line}/>
    </div>;
};

interface I_edit_element_form_props {
    id: string;
    elements: I_element[];
    on_save: (v:I_element)=>void;
    on_cancel: ()=>void;
}
const Edit_element_form = (props:I_edit_element_form_props)=>{
    const [edit, set_edit] = useState<I_element>();
    const [json, set_json] = useState('');
    const {app_settings} = useContext(Settings_context);
    const {pathname} = use_pathname();
    const resolvers = useMemo(()=>{
        return {
            ...app_settings?.resolvers,
        };
    }, [app_settings?.resolvers]);
    useEffect(()=>{
        const edit_obj = app_settings?.overrides?.[pathname]?.[props.id]
            || props.elements.find(el=>el.id == props.id);
        set_edit(edit_obj ? {...edit_obj} : undefined);
        if (edit_obj)
            set_json(JSON.stringify(edit_obj.props));
        else
            set_json('');
    }, [props.id, props.elements]);
    const Editor = resolvers[edit?.type]?.editor || null;
    if (!edit)
      return null;
    return <div>
      <Input value={edit.type} on_change={v=>{
        set_edit({...edit, type: v});
      }} label={'Type'}/>
      <Checkbox checked={!!edit.container_wrap} on_change={v=>{
        set_edit({...edit, container_wrap: v});
      }} caption='Wrap with Container' />
      <Checkbox checked={!!edit.client_side_rendering} on_change={v=>{
        set_edit({...edit, client_side_rendering: v});
      }} caption='Client-side only'/>
      <Checkbox checked={!!edit.client_alive_rendering} on_change={v=>{
        set_edit({...edit, client_alive_rendering: v});
      }} caption='Client alive only'/>
      {Editor ?
        <div className={styles.block_props}>
          <h4>Block props:</h4>
          <Editor value={edit?.props} on_cancel={()=>props.on_cancel()}
            on_change={new_props=>{
              set_edit(c_edit=>({...c_edit, props: new_props}));
              set_json(JSON.stringify(new_props));
            }}/>
        </div>: null}
      <Textarea value={json} on_change={set_json} placeholder={'props'}/>
      <Button caption={'Save'} on_click={()=>{
        try {
          edit.props = JSON.parse(json);
        } catch(e){}
        props.on_save(edit);
      }} size={'sm'}/>
      <Button caption={'Cancel'} on_click={()=>{
        props.on_cancel();
      }} size={'sm'}/>
    </div>;
};

interface i_meta_state {
    meta: {
        title: string;
        description: string;
        canonical_url: string;
        keywords: string;
        og_title: string;
        og_description: string;
        og_image: string;
        og_url: string;
        author: string;
        published_time: string;
        robots: string;
    };
    url: string;
    page_bg?: string;
    use_page_container?: boolean;
    headless?: boolean;
    footless?: boolean;
    footer_opt?: {
        gradient_color?: string;
        hide_cta?: boolean;
        no_content?: boolean;
    };
    nav_opt?: {
        compact_mode?: boolean;
    };
}

interface I_list_of_elements_props {
    on_drag_start: (element: I_element)=>void;
    just_meta?: boolean;
}
const List_of_elements = (props:I_list_of_elements_props)=>{
    const basic_elements = useMemo(()=>{
        return [];
    }, []);
    const {app_settings} = useContext(Settings_context);
    const {pathname} = use_pathname();
    const [copy, set_copy] = useState('');
    const meta_conf = app_settings?.meta?.[pathname] || {};
    const overrides = app_settings?.overrides?.[pathname] || {};
    const resolvers = useMemo(()=>{
        return {
            ...app_settings?.resolvers,
        };
    }, [app_settings?.resolvers]);
    const [meta, set_meta] = useState<i_meta_state>({meta: {title: '',
        description: '', canonical_url: '', keywords: '', og_title: '',
        og_description: '', og_image: '', og_url: '', author: '',
        published_time: '', robots: ''}, url: '', footless: undefined,
        headless: undefined, footer_opt: {}});
    const with_footer = !meta.footless;
    useEffect(()=>{
        set_meta({...meta_conf});
    }, [JSON.stringify(meta_conf)]);
    const resolvers_keys = Object.keys(resolvers);
    const list = [...basic_elements, ...resolvers_keys.map(r=>({
        type: r,
        container_wrap: !!resolvers[r].container_wrap,
        props: resolvers[r].props || {},
    }))];
    return <div className={styles.elements}>
      <h4>Page meta:</h4>
      <Input value={meta?.meta?.title || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, title: v}})}
        label={'Title'} />
      <Input value={meta?.meta?.description || ''}
        on_change={v=>set_meta({...meta, meta: {
          ...meta.meta, description: v}})}
        label={'description'} />
      <Input value={meta?.meta?.canonical_url || ''}
        on_change={v=>set_meta({...meta, meta: {
          ...meta.meta, canonical_url: v}})}
        label={'canonical_url'} />
      <Input value={meta?.meta?.keywords || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, keywords: v}})}
        label={'keywords'} />
      <Input value={meta?.meta?.og_title || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, og_title: v}})}
        label={'og_title'} />
      <Input value={meta?.meta?.og_description || ''}
        on_change={v=>set_meta({...meta, meta: {
          ...meta.meta, og_description: v}})}
        label={'og_description'} />
      <Input value={meta?.meta?.og_image || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, og_image: v}})}
        label={'og_image'} />
      <Input value={meta?.meta?.og_url || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, og_url: v}})}
        label={'og_url'} />
      <Input value={meta?.meta?.author || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, author: v}})}
        label={'author'} />
      <Input value={meta?.meta?.published_time || ''}
        on_change={v=>set_meta({...meta, meta: {
          ...meta.meta, published_time: v}})}
        label={'published_time'} />
      <Input value={meta?.meta?.robots || ''}
        on_change={v=>set_meta({...meta, meta: {...meta.meta, robots: v}})}
        label={'Robots'} />
      <Input value={meta.url} on_change={v=>set_meta({...meta, url: v})}
        label={'Url'} />
      <Input value={meta.page_bg}
        on_change={v=>set_meta({...meta, page_bg: v})}
        label={'Page background'} />
      <Checkbox checked={!!meta.use_page_container}
        caption={'Use page container'}
        on_change={v=>set_meta({...meta, use_page_container: v})}/>
      <Checkbox checked={!meta.headless} caption={'With header'}
        on_change={v=>set_meta({...meta, headless: !v})}/>
      <Checkbox checked={with_footer} caption={'With footer'}
        on_change={v=>set_meta({...meta, footless: !v})}/>
      {!meta.headless && <Checkbox
        checked={!!meta.nav_opt?.compact_mode}
        caption={'Use compact navbar'}
        on_change={v=>set_meta({...meta, nav_opt: {...meta.nav_opt || {},
          compact_mode: v
        }})}/>
      }
      {with_footer && <div>
        <Input
          value={meta.footer_opt?.gradient_color || ''}
          on_change={v=>set_meta({...meta, footer_opt: {
            ...meta.footer_opt, gradient_color: v}})}
          label={'Footer Background Color'}/>
        <Checkbox
          checked={!!meta.footer_opt?.hide_cta} caption={'Hide CTA'}
          on_change={v=>set_meta({...meta, footer_opt: {
            ...meta.footer_opt, hide_cta: v}})}/>
        <Checkbox
          checked={!!meta.footer_opt?.no_content} caption={'No Content'}
          on_change={v=>set_meta({...meta, footer_opt: {
            ...meta.footer_opt, no_content: v}})}/>
        </div>
      }
      <Button caption={'Save Meta'} size={'sm'} on_click={()=>{
        app_settings.save_meta(pathname, meta);
      }} />
      <div className={styles.copy_section}>
        <Input value={copy} on_change={set_copy}
          label={'Copy to (new page id)'} />
        <Button caption={'Copy page'} size={'sm'} on_click={()=>{
          app_settings.save_overrides(copy, {
            ...overrides,
          });
        }} />
      </div>
      {!props.just_meta && <Fragment>
        <h3>Drag&Drop Elements:</h3>
        {list.map((el, i)=>{
          return <div draggable={true} className={styles.element} key={i}
            onDragStart={()=>{
              props.on_drag_start({...el, id: `id${Date.now()}`,
                props: {...el.props || {}}});
            }}>{el.type}</div>;
        })}
      </Fragment>}
    </div>;
};

export const Content = (props:I_content_props)=>{
    const {height, width} = use_screen();
    const {is_client, is_client_alive} = use_client();
    const {app_settings, theme} = useContext(Settings_context);
    const {pathname} = use_pathname();
    const resolvers = useMemo(()=>{
        return {
            ...app_settings?.resolvers,
        };
    }, [app_settings?.resolvers]);
    const overrides = app_settings?.overrides?.[pathname] || {};
    const meta_conf = app_settings?.meta?.[pathname] || {};
    const elements = overrides.root as I_element[] || props.elements || [];
    const on_add = (position: number, element?: I_element)=>{
        if (element)
        {
            app_settings.save_overrides(pathname, {
                ...overrides,
                root: elements.slice(0, position).concat([element])
                    .concat(elements.slice(position, elements.length)),
            });
            return;
        }
        app_settings.save_overrides(pathname, {
            ...overrides,
            root: elements.slice(0, position).concat([{
                id: `id${Date.now()}`,
                type: 'Html',
                props: {...resolvers?.Html?.props || {}},
                container_wrap: true,
            }]).concat(elements.slice(position, elements.length))
        });
    };
    const on_remove = (index: number)=>{
        app_settings.save_overrides(pathname, {
            ...overrides,
            root: elements.slice(0, index)
                .concat(elements.slice(index+1, elements.length)),
        });
    };
    useEffect(()=>{
        const all_e = document.getElementsByClassName(styles.edit_element);
        for (let i=0; i<all_e.length; i++)
        {
            const next = all_e[i].nextElementSibling;
            if (!next)
              return;
            // @ts-ignore
            const next_h = next.offsetHeight || 0;
            // @ts-ignore
            all_e[i].style.minHeight = `${next_h}px`;
        }
    }, [app_settings?.overrides, is_client, width, height]);
    const [edit_element, set_edit_element] = useState<string>();
    const [drag_element, set_drag_element] = useState<I_element>();
    const edit_mode = app_settings.edit_mode && is_client;
    if (overrides.loading)
      return <Fragment></Fragment>;
    if (overrides.error)
      return <Fragment></Fragment>;
    return <Fragment>
      {edit_mode && <div className={cn(styles.right_stack,
        edit_element && styles.edit_element_stack)}>
        {edit_element ? <Edit_element_form id={edit_element}
          elements={elements}
          on_cancel={()=>set_edit_element(undefined)}
          on_save={new_element=>{
            if (new_element.is_from_react_app)
            {
              app_settings.save_overrides(pathname, {
                ...overrides,
                [new_element.id]: new_element,
              });
              set_edit_element(undefined);
              return;
            }
            const ind = elements.findIndex(e=>e.id==new_element.id);
            const new_elements = [...elements];
            new_elements[ind] = new_element;
            app_settings.save_overrides(pathname, {
              ...overrides,
              root: new_elements,
            });
            set_edit_element(undefined);
          }}/> : <div>
          <List_of_elements on_drag_start={set_drag_element}
            just_meta={props.just_meta}/>
        </div>}
      </div>}
      {!props.just_meta && edit_mode && !meta_conf.headless && <div
        className={styles.header_spacer}/>}
      {!props.just_meta && edit_mode && <Add_element
        on_add={()=>on_add(0)} on_drop={()=>on_add(0, drag_element)}/>}
      {!props.just_meta && elements.map((el, i)=>{
        const el_overrided = overrides[el.id] || el;
        if (!is_client && el?.client_side_rendering)
            return null;
        if (!is_client_alive && el?.client_alive_rendering)
            return null;
        const Cmp = resolvers[el_overrided.type]?.tag || el_overrided.type;
        return <Fragment key={i}>
          {app_settings.edit_mode && <div className={styles.edit_element}>
            <Button caption={'edit next'} on_click={()=>{
              set_edit_element(el.id);
            }} size={'xxs'}/>
            <Button caption={'remove element'} on_click={()=>{
              on_remove(i);
            }} size={'xxs'}/>
          </div>}
          {el.container_wrap ?
            <div className={theme.container}>
              <Cmp {...el_overrided.props}/>
            </div> : <Cmp {...el_overrided.props}/>}
          {app_settings.edit_mode && <Add_element on_add={()=>on_add(i+1)}
            on_drop={()=>on_add(i+1, drag_element)}/>}
        </Fragment>;
      })}
    </Fragment>;
};
